import request from '@/utils/request'

export function getStatusCounts() {
  return request({
    url: '/tms/container/status-counts',
    method: 'get'
  })
}

export function getInTransitValue() {
  return request({
    url: '/tms/dashboard/in-transit-value',
    method: 'get'
  })
}

// 分页查询集装箱列表
export function getContainerList(params) {
  return request({
    url: '/tms/container/list',
    method: 'post',
    data: params
  })
}
/**
 * 创建集装箱（含装箱明细）
 * 接口：POST /tms/container/create-with-items
 * 只传 rawCode + totalValue + etd + eta + remark + items
 */
export function createContainer(data) {
  return request({
    url: '/tms/container/create-with-items',
    method: 'post',
    data: data
  })
}
// 确认到岗
export function confirmArrival(id) {
  return request({
    url: '/tms/container/confirm-arrival',
    method: 'put',
    data: { id }
  })
}

export function confirmCustomsClearance(data) {
  return request({
    url: '/tms/container/customs-clearance',
    method: 'put',
    data: data
  })
}

export function confirmDelivery(data) {
  return request({
    url: '/tms/container/delivery',
    method: 'put',
    data: data
  })
}

export function warehouseCheck(data) {
  return request({
    url: '/tms/container/warehouse-check',
    method: 'put',
    data: data
  })
}
// 上传图片
export function uploadFiles(formData) {
  return request({
    url: '/common/uploads',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function erpCheck(data) {
  return request({
    url: '/tms/container/erp-check',
    method: 'put',
    data: data
  })
}

/**
 * xlsx 智能导入装箱明细
 * @param {FormData} formData - 包含 file 字段的表单数据
 */
export function importAuto(formData) {
  return request({
    url: '/tms/container/items/import-auto',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 查询集装箱详情
 * @param {string} id - 集装箱UUID
 * @param {string} language - 语言：zh 或 pt
 */
export function getContainerDetail(id, language = 'zh') {
  return request({
    url: `/tms/container/get?id=${id}&language=${language}`,
    method: 'get'
  })
}

/**
 * 分页查询指定集装箱的装箱明细
 * @param {string} containerId - 集装箱UUID
 * @param {Object} params - 分页参数 { pageNum, pageSize }
 */
export function getContainerItems(containerId, params) {
  return request({
    url: `/tms/container/items/list`,
    method: 'get',
    params: { containerId, ...params }
  })
}

/**
 * 导出报表
 * @param {Object} data - 导出参数 { type, language }
 * @param {string} data.type - 导出类型：full / cargo-list / in-transit
 * @param {string} data.language - 语言：zh 或 pt
 */
export function exportXlsx(data) {
  return request({
    url: '/tms/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
export function exportDetail(data) {
  return request({
    url: '/tms/container/export-detail',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

/**
 * 导出货柜报表（含金额）
 * POST /tms/container/export-with-amount
 * @param {Object} data - 导出参数
 * @param {string} data.containerId - 集装箱UUID（必填，只导出这一个货柜）
 * @param {boolean} data.withContainer - true=导出完整清单 / false=导出装箱清单（默认 true）
 */
export function exportContainerWithAmount(data) {
  return request({
    url: '/tms/container/export-with-amount',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

/**
 * 状态回滚接口 / 备注保存接口（共用）
 * PUT /tms/container/edit
 * @param {Object} data - 更新参数
 *   - 回滚时：{ id, status }
 *   - 备注保存时：{ id, remark, status, remarkImage }
 *     - remark: 备注内容
 *     - status: 状态（已启运为1）
 *     - remarkImage: 图片URL数组
 */
export function rollbackContainer(data) {
  return request({
    url: '/tms/container/edit',
    method: 'put',
    data: data
  })
}

/**
 * 更新集装箱时间信息（ETD/ETA/ATA）
 * @param {Object} data - 更新参数 { id, etd, eta, ata }
 */
export function updateContainerTimes(data) {
  return request({
    url: '/tms/container/update-times',
    method: 'put',
    data: data
  })
}

/**
 * 删除集装箱
 * @param {string} id - 集装箱id
 */
export function deleteContainer(id) {
  return request({
    url: `/tms/container/${id}`,
    method: 'delete'
  })
}

/**
 * 月度到港趋势（堆叠折线图）
 * @param {Object} params - { year: 2026 }
 */
export function getArrivalTrend(params) {
  return request({
    url: '/tms/dashboard/arrival-trend',
    method: 'get',
    params
  })
}